import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=1d3a2ff6&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=1d3a2ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3a2ff6",
  null
  
)

export default component.exports